import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { onEnter, onExit } from "../../../../config/customModalFunctions";
import { FormattedMessage } from 'react-intl';
import {
  getLocalHourOnRomaniaTimeZone,
} from '../../../../config/constants';

function UserDetails(props) {
  const { showModal, closeModal, user, event } = props;

  return (
    <Modal
      isOpen={showModal}
      toggle={closeModal}
      size="lg"
      onEnter={onEnter}
      onExit={onExit}
      centered
      returnFocusAfterClose={false}
    >
      <ModalHeader className="pb-0" toggle={closeModal}>
        <FormattedMessage id="pages.appointments.modal.appointment_details"/>
      </ModalHeader>

      <ModalBody>
        <FormattedMessage id="pages.appointments.modal.appointment_details_body"
                          values={{
                            user: user,
                            date: getLocalHourOnRomaniaTimeZone(event.start, true),
                            hour: getLocalHourOnRomaniaTimeZone(event.start),
                          }}/>
      </ModalBody>
    </Modal>
  );
}

export { UserDetails };
